<template>
  <div class="home-pc">
    <div class="home-pc__spacer"></div>
    <div class="home-pc__title">
      <Title></Title>
    </div>
    <div class="home-pc__nav">
      <div class="home-pc__grid">
        <div class="home-pc__cell">
          <my-button
            title="乐器练习"
            href="Sound"
            bg-color="linear-gradient(90deg, rgb(39, 122, 218), rgb(74, 230, 121), rgb(243, 169, 10), rgb(226, 20, 233), rgb(16, 172, 219))"
          ></my-button>
        </div>
        <div class="home-pc__cell">
          <my-button
            title="团队视频"
            href="ShowVideo"
            bg-color="linear-gradient(90deg, #fc6076, #ff9a44, #ef9d43, #e75516)"
          ></my-button>
        </div>
        <div class="home-pc__cell">
          <my-button
            title="乐声播放"
            href="MusicList"
            bg-color="linear-gradient(90deg,#009245, #FCEE21, #00A8C5, #D9E021)"
          ></my-button>
        </div>
        <div class="home-pc__cell">
          <my-button
            title="VR接入"
            href="VrGuide"
            bg-color="linear-gradient(90deg, #00c6fb, #005bea, #00d2ff, #3a7bd5)"
          ></my-button>
        </div>
        <div class="home-pc__cell home-pc__cell--wide">
          <my-button
            title="更多"
            href="More"
            bg-color="linear-gradient(90deg, #667eea, #764ba2, #6B8DD6, #8E37D7)"
          ></my-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import MyButton from '@/components/MyButton.vue'
export default {
  name: 'Home',
  components: {
    MyButton,
    Title
  }
}
</script>

<style lang="less" scoped>
.home-pc__spacer {
  width: 100%;
  height: 60px;
}
.home-pc__title {
  width: 100%;
}
.home-pc__nav {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 80px;
  padding-bottom: 80px;
  box-sizing: border-box;
}
.home-pc__grid {
  width: min(1100px, 90%);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 48px 24px;
  justify-items: center;
  align-items: center;
}
.home-pc__cell {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-pc__cell--wide {
  grid-column: 1 / -1;
}

/* 三行按钮时略缩小，避免挤在一起 */
.home-pc__grid /deep/ .guang {
  width: min(480px, 100%);
  height: 180px;
  font-size: 40pt;
  line-height: 1.2;
  border-radius: 28px;
}
.home-pc__grid /deep/ .guang::before {
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  top: -10px;
  left: -10px;
}
</style>
